import React, { useState } from 'react'
import useActiveState from '../../lib/useActiveState';
import Dialog from '../../lib/Dialog';
import { useLockFn } from 'ahooks';
import general from '../../general';
import { Mask } from 'antd-mobile';
export default function AuthAlert(props) {

  const [config] = useActiveState('config');
  const [authData, setAuthData] = useState({}); //实名认证参数值
  const isCheckAuth = props.isCheckAuth; //实名认证弹框状态

  const certifiy = useLockFn(() => {
    if (!authData.real_name) {
      Dialog.info('请输入姓名');
      return;
    }
    if (!authData.identity_card) {
      Dialog.info('请输入身份证号');
      return;
    }
    Dialog.loading();
    general.axios.post('/user/user/editMemberInfo', { real_name: authData.real_name, identity_card: authData.identity_card })
      .finally(() => {
        Dialog.close();
      })
      .then(res => {
        let { status, data } = res.data;

        if (!status.succeed) {
          Dialog.info(status.error_desc);
        } else {
          Dialog.info("认证成功");
          if (props.handleAuthSuccess) {
            const info = { real_name: authData.real_name, identity_card: authData.identity_card, isRealNameAuth: true, isAdult: data.isAdult }
            props.handleAuthSuccess(info)
          }
          if (props.onClose) {
            props.onClose()
          }
        }
      })
      .catch(err => {
        Dialog.error(err.message);
      });
  })

  return (
    <Mask visible={isCheckAuth} getContainer={document.getElementById('root')} color='transparent'>
      <div>
        {isCheckAuth && <div className="pay-check-auth">
          <div className="auth-index">
            <div className="close" onClick={() => {
              if (props.onClose) {
                props.onClose()
              }
            }}>
              <img src="/resources/user/close.png" />
            </div>
            <div className="title">
              <div className="title-img">
                <img src="/resources/user/auth-title.png" />
              </div>
              <div>
                <h3>实名认证</h3>
                <p>
                  {config.authTopTips}
                </p>
              </div>
            </div>

            <div className="auth-user-realname">
              <div className="auth-user-input">
                <div className="name">真实姓名</div>
                <input name="nick_name" type="text" placeholder="请输入姓名" autocomplete="off" value={authData.real_name} onChange={e => setAuthData({ ...authData, real_name: e.target.value })} />
              </div>
              <div className="auth-user-input">
                <div className="name">身份证号</div>
                <input name="number" type="text" placeholder="请输入身份证号" autocomplete="off" value={authData.identity_card} onChange={e => setAuthData({ ...authData, identity_card: e.target.value })} />
              </div>
              <span>
                {config.authBottomTips}
              </span>
              <div className="auth-user-btn" onClick={certifiy}>立即认证</div>
            </div>
          </div>
        </div>}
      </div>
    </Mask>
  )
}
